/**
 * /pass/affiliate — Standalone affiliate dashboard.
 * Auth: customer_token (marketplace customer). Reuses MarketplaceLayout
 * so it feels like a sibling of /mi-cuenta.
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';
import MarketplaceLayout from '../../components/marketplace/MarketplaceLayout';
import AffiliateAccountContent from './AffiliateAccountContent';

export default function AffiliateDashboard() {
  return (
    <MarketplaceLayout>
      <Helmet>
        <title>Portal de afiliado — Todo en Local Pass</title>
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
        <AffiliateAccountContent />
      </div>
    </MarketplaceLayout>
  );
}
